/**
 * Created by BETALOS on 04/12/2015.
 */
(function () {

    'use strict';

    module.exports = require('./components/image-edition');

})();